import PropTypes from "prop-types"
import React from "react"
import { Link } from 'gatsby'
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { document } from 'browser-monads';

export default function Menu() {
  const eclipse = (e) => {
    document.body.classList.toggle("midnight");
  };

  const menuOpen = (e) => {
    document.body.classList.toggle("menu-open");
  };

  const closeMenu = (e) => {
    console.log('clicked');
    document.body.classList.remove("menu-open");
  };

  return (
    <aside role="region">
    
      <AniLink onClick={closeMenu} aria-label="Logo Home Link" className="logo" name="logo" cover direction="right" to="/">
        <svg version="1.1" viewBox="0 0 62.5 28.7">
          <g>
            <polygon
              className="s-line"
              points="27.9,14.4 13,8.1 23.4,19.8 4.5,28.4 15.7,18.4 0.4,0.3 27.9,7.1 	"
            />
            <polyline
              className="r-line"
              points="30.1,6.8 30.1,28.4 35.8,13.9 49.6,8.1 39.2,19.8 58,28.5 46.9,18.4 62.3,0.4 30.1,6.8 	"
            />
          </g>
        </svg>
      </AniLink>
      <nav className="utility" role="navigation">
        <ul>
          <li>
            <Link to="#websites" title="Our team">
              <div>Websites</div>
            </Link>
          </li>
          {/* <li>
            <Link to="#designs" title="Our team">
              <div>Designs</div>
            </Link>
          </li> */}
          <li>
            <Link to="#photography" title="Our team">
              <div>Photos</div>
            </Link>
          </li>
        </ul>
      </nav>
      <button className="menu-toggle" onClick={menuOpen}>
        <div className="menu-title">Menu</div>
        <div className="burger">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
      <button name="toggle" className="eclipse" onClick={eclipse}>
        <svg className="moon" viewBox="0 0 11.6 11.7">
          <path
            className="st0"
            d="M4.1,7.2c-1.5-2-1.1-4.8,0.8-6.3c0.4-0.3,0.8-0.5,1.3-0.7C4.9,0.1,3.6,0.5,2.4,1.4C0,3.3-0.5,6.8,1.4,9.3
c1.9,2.5,5.5,3,7.9,1.1c1.1-0.9,1.8-2,2.1-3.3c-0.3,0.4-0.6,0.7-1,1C8.4,9.6,5.6,9.2,4.1,7.2z"
          />
        </svg>
        Toggle Night Mode
      </button>
      <div className="triangles"></div>
      <div className="bottom-tri"></div>
      <nav className="menu" role="navigation">
        <ul>
          <li>
            <AniLink onClick={closeMenu} cover direction="right" to="/">Home</AniLink>
          </li>
          <li>
            <AniLink onClick={closeMenu} cover direction="right" to="/about"
            >About</AniLink>
          </li>
          <li>
            <Link onClick={closeMenu} to="/#websites">Websites</Link>
          </li>
          {/* <li>
            <Link onClick={closeMenu} to="/#designs" title="Our team">
              <span>Designs</span>
            </Link>
          </li> */}
          <li>
            <Link onClick={closeMenu} to="/#photography" title="Our team">
              <span>Photography</span>
            </Link>
          </li>
        </ul>
        <ul className="sub-menu">
          <li>
            <AniLink onClick={closeMenu} cover direction="right" to="/portraits"
            >Portraits</AniLink>
          </li>

          <li>
            <AniLink onClick={closeMenu} cover direction="right" to="/cosplay"
            >Cosplay</AniLink>
          </li>
        </ul>
        {/* <div className="eyebrow">
          <nav className="social-media" role="navigation">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://instagram.com/sathya.ram"
            >
              <svg viewBox="0 0 512 512">
                <g>
                  <path d="M256 109.3c47.8 0 53.4 0.2 72.3 1 17.4 0.8 26.9 3.7 33.2 6.2 8.4 3.2 14.3 7.1 20.6 13.4 6.3 6.3 10.1 12.2 13.4 20.6 2.5 6.3 5.4 15.8 6.2 33.2 0.9 18.9 1 24.5 1 72.3s-0.2 53.4-1 72.3c-0.8 17.4-3.7 26.9-6.2 33.2 -3.2 8.4-7.1 14.3-13.4 20.6 -6.3 6.3-12.2 10.1-20.6 13.4 -6.3 2.5-15.8 5.4-33.2 6.2 -18.9 0.9-24.5 1-72.3 1s-53.4-0.2-72.3-1c-17.4-0.8-26.9-3.7-33.2-6.2 -8.4-3.2-14.3-7.1-20.6-13.4 -6.3-6.3-10.1-12.2-13.4-20.6 -2.5-6.3-5.4-15.8-6.2-33.2 -0.9-18.9-1-24.5-1-72.3s0.2-53.4 1-72.3c0.8-17.4 3.7-26.9 6.2-33.2 3.2-8.4 7.1-14.3 13.4-20.6 6.3-6.3 12.2-10.1 20.6-13.4 6.3-2.5 15.8-5.4 33.2-6.2C202.6 109.5 208.2 109.3 256 109.3M256 77.1c-48.6 0-54.7 0.2-73.8 1.1 -19 0.9-32.1 3.9-43.4 8.3 -11.8 4.6-21.7 10.7-31.7 20.6 -9.9 9.9-16.1 19.9-20.6 31.7 -4.4 11.4-7.4 24.4-8.3 43.4 -0.9 19.1-1.1 25.2-1.1 73.8 0 48.6 0.2 54.7 1.1 73.8 0.9 19 3.9 32.1 8.3 43.4 4.6 11.8 10.7 21.7 20.6 31.7 9.9 9.9 19.9 16.1 31.7 20.6 11.4 4.4 24.4 7.4 43.4 8.3 19.1 0.9 25.2 1.1 73.8 1.1s54.7-0.2 73.8-1.1c19-0.9 32.1-3.9 43.4-8.3 11.8-4.6 21.7-10.7 31.7-20.6 9.9-9.9 16.1-19.9 20.6-31.7 4.4-11.4 7.4-24.4 8.3-43.4 0.9-19.1 1.1-25.2 1.1-73.8s-0.2-54.7-1.1-73.8c-0.9-19-3.9-32.1-8.3-43.4 -4.6-11.8-10.7-21.7-20.6-31.7 -9.9-9.9-19.9-16.1-31.7-20.6 -11.4-4.4-24.4-7.4-43.4-8.3C310.7 77.3 304.6 77.1 256 77.1L256 77.1z"></path>
                  <path d="M256 164.1c-50.7 0-91.9 41.1-91.9 91.9s41.1 91.9 91.9 91.9 91.9-41.1 91.9-91.9S306.7 164.1 256 164.1zM256 315.6c-32.9 0-59.6-26.7-59.6-59.6s26.7-59.6 59.6-59.6 59.6 26.7 59.6 59.6S288.9 315.6 256 315.6z"></path>
                  <circle cx="351.5" cy="160.5" r="21.5"></circle>
                </g>
              </svg>
              <span>Instagram</span>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://dribbble.com/sathyaram"
            >
              <svg viewBox="0 0 512 512">
                <path d="M256 68.4C152.4 68.4 68.4 152.4 68.4 256c0 103.6 84 187.6 187.6 187.6S443.6 359.6 443.6 256C443.6 152.4 359.6 68.4 256 68.4zM410.6 247.3c-40.3-6.6-77.3-7-111-1.1 -3.8-8.8-7.8-17.6-12-26.3 36.1-15.6 65.1-36.9 86.7-63.8C395.4 181 408.6 212.6 410.6 247.3zM350.5 133.4c-18.8 24.3-44.8 43.5-78 57.5 -15.9-29.1-34-57.5-54.5-85 12.2-3.1 24.9-4.9 38-4.9C291.6 101 324.3 113.2 350.5 133.4zM186.1 117.9c20.8 27.2 39.3 55.3 55.3 84.1 -38 11.2-83.4 16.9-135.8 17.3C116.4 175 146.3 138.1 186.1 117.9zM101 256c0-1.3 0.2-2.7 0.2-4 60.2-0.1 112.1-7 155.6-20.7 3.6 7.4 7.1 14.9 10.5 22.4 -52.8 16.5-96.4 50.4-130.3 101.3C114.5 328.2 101 293.6 101 256zM160.9 378.1c30.8-48.3 70.1-79.7 118.8-94.2 14.5 37.8 25.2 76.8 31.9 116.6 -17.3 6.7-36 10.5-55.6 10.5C220.1 411 187.2 398.6 160.9 378.1zM342 384.8c-6.9-36.8-16.9-72.8-30-107.8 29.3-4.1 61.6-3.1 96.9 3.1C402.1 323.6 377.2 361.3 342 384.8z" />
              </svg>
              <span>Dribbble</span>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/sathyaram"
            >
              <svg viewBox="0 0 512 512">
                <path d="M256 70.7c-102.6 0-185.9 83.2-185.9 185.9 0 82.1 53.3 151.8 127.1 176.4 9.3 1.7 12.3-4 12.3-8.9V389.4c-51.7 11.3-62.5-21.9-62.5-21.9 -8.4-21.5-20.6-27.2-20.6-27.2 -16.9-11.5 1.3-11.3 1.3-11.3 18.7 1.3 28.5 19.2 28.5 19.2 16.6 28.4 43.5 20.2 54.1 15.4 1.7-12 6.5-20.2 11.8-24.9 -41.3-4.7-84.7-20.6-84.7-91.9 0-20.3 7.3-36.9 19.2-49.9 -1.9-4.7-8.3-23.6 1.8-49.2 0 0 15.6-5 51.1 19.1 14.8-4.1 30.7-6.2 46.5-6.3 15.8 0.1 31.7 2.1 46.6 6.3 35.5-24 51.1-19.1 51.1-19.1 10.1 25.6 3.8 44.5 1.8 49.2 11.9 13 19.1 29.6 19.1 49.9 0 71.4-43.5 87.1-84.9 91.7 6.7 5.8 12.8 17.1 12.8 34.4 0 24.9 0 44.9 0 51 0 4.9 3 10.7 12.4 8.9 73.8-24.6 127-94.3 127-176.4C441.9 153.9 358.6 70.7 256 70.7z"></path>
              </svg>
              <span>Github</span>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://codepen.io/sathyaram"
            >
              <svg viewBox="0 0 512 512">
                <path d="M427 201.9c-0.6-4.2-2.9-8-6.4-10.3L264.2 87.3c-4.9-3.3-11.4-3.3-16.3 0L91.4 191.6c-4 2.7-6.5 7.4-6.5 12.2v104.3c0 4.8 2.5 9.6 6.5 12.2l156.4 104.3c4.9 3.3 11.4 3.3 16.3 0L420.6 320.4c4-2.6 6.6-7.4 6.6-12.2V203.9C427.1 203.2 427.1 202.6 427 201.9 427 201.7 427.1 202.6 427 201.9zM270.7 127.1l115.2 76.8 -51.5 34.4 -63.8-42.7V127.1zM241.3 127.1v68.6l-63.8 42.7 -51.5-34.4L241.3 127.1zM114.3 231.4l36.8 24.6 -36.8 24.6V231.4zM241.3 384.9L126.1 308.1l51.5-34.4 63.8 42.6V384.9zM256 290.8l-52-34.8 52-34.8 52 34.8L256 290.8zM270.7 384.9V316.3l63.8-42.6 51.5 34.4L270.7 384.9zM397.7 280.6l-36.8-24.6 36.8-24.6V280.6z" />
              </svg>
              <span>Codepen</span>
            </a>
          </nav>
          <div className="scroll-down">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <nav className="contact" role="navigation">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="SathyaRam_Resume2021.pdf"
            >
              Resume
          </a>
            <a
              className="music"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/watch?v=MXkZ-eeGs6A"
            >
              ✧
          </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/sathya-ram/"
            >
              LinkedIn
          </a>
            <a
              className="music"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/watch?v=-4FWJmHfLC0"
            >
              ✧
          </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:sathyatheram@gmail.com"
            >
              Email
          </a>
          </nav>
        </div> */}
      </nav>
    </aside>
  )
}

Menu.propTypes = {
  siteTitle: PropTypes.string,
}

Menu.defaultProps = {
  siteTitle: ``,
}
